import React from 'react';
import ContactTile from '@gik/contact/components/ContactTile/ContactTile';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/contact/i18n/en';

export default function KnowledgeBase() {
  const bem = useBemCN('knowledge-base');
  const { t } = useTranslation();

  return (
    <ContactTile
      {...bem()}
      title={t(translationKeys.KnowledgeBaseTitle)}
      buttonText={t(translationKeys.KnowledgeBaseButtonText)}
      buttonLink="https://help.giveinkind.com/en/"
    >
      {t(translationKeys.KnowledgeBaseContent)}
    </ContactTile>
  );
}
